import { Box } from '@mui/material';

import { CaseFormType } from '../../../../types';
import styles from './CaseFormsToolbar.module.css';
import { CreateCaseFormButton } from './CreateCaseForm';

interface CaseFormsToolbarProps {
    caseForms: CaseFormType[];
}

export const CaseFormsToolbar = ({ caseForms }: CaseFormsToolbarProps) => {
    return (
        <Box display="flex" alignItems="center" className={styles.toolbarWrapper}>
            <CreateCaseFormButton caseForms={caseForms} />
        </Box>
    );
};
